<template>
  <div class="buy-card" @click="toDetail()">
    <van-image class="buy-cover" fit="cover" 
    :error-icon="$placeImg"
    :loading-icon="$placeImg"
    :src="cardData.cover" alt="" ></van-image>
    <div class="buy-msg">
      <div class="buy-name ellipsis_two">{{ cardData.name }}</div>
      <div class="buy-des ellipsis">购买时间：{{ cardData.star_time }}</div>
      <div class="date-des ellipsis" v-if="!isPass">{{ cardData.end_time.slice(0,10) }}到期</div>
      <div class="date-pass" v-else>已过期</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cardData: {
      type: Object,
      default: {},
      required: true,
      validator: function (value) {
        return value;
      },
    },
  },
  computed: {
    isPass(){
      return new Date().getTime() - new Date(this.cardData.end_time).getTime() > 0
    }
  },
  data() {
    return {};
  },
  onLoad() {},
  methods: {
    toDetail(){
      this.$router.push({
        path:'../detailYingyou',
        query:{
          id:this.cardData.id,
          type:'video'
        }
      })
    }
  },
};
</script>

<style scoped>
.buy-card {
  width: 100%;
  display: flex;
  padding: 0 32px 32px;
  box-sizing: border-box;
}

.buy-card:last-of-type {
  margin-bottom: 0;
}

.buy-cover {
  width: 256px;
  height: 144px;
  border-radius: 12px;
  display: block;
  flex: 0 1 296px;
  margin-right: 24px;
  overflow: hidden;
}

.buy-msg {
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
}

.buy-name {
  font-size: 28px;
  color: #000;
  font-weight: 500;
  width: 100%;
  margin-bottom: 10px;
}

.buy-des {
  font-size: 20px;  
  color: #999;
  font-weight: 400;
  width: 100%;
  line-height: 1.6;
  flex:1;
}

.date-des {
  font-size: 28px;
  font-weight: 500;
  color: #F08E00;
}
.date-pass{
  font-size: 28px;
  font-weight: 500;
  color: #CCCCCC;
  line-height: 1.6;
}
</style>>
